document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".card_productGrid__formItem").forEach((item) => {
    const decreaseButton = item.querySelector(".quantity-decrease");
    const increaseButton = item.querySelector(".quantity-increase");
    const radioButtons = item.querySelectorAll('input[type="radio"]');
    const addToCartButton = item.querySelector(".dn-add-to-cart-btn");

    if (!decreaseButton || !increaseButton || !addToCartButton) {
      return;
    }

    decreaseButton.addEventListener("click", decreaseQuantity);
    increaseButton.addEventListener("click", increaseQuantity);

    radioButtons.forEach((radio) => {
      radio.addEventListener("change", () => {
        item.querySelector(".quantity-input").value = 1;
        updatePrice();
      });
    });

    addToCartButton.addEventListener("click", function () {
      if (this.disabled) return;  
      this.disabled = true;
      this.textContent = "Adding...";

      const parentElement = this.closest(".card_productGrid__formItem");
      const quantity = parentElement.querySelector(".quantity-input").value;
      const variantId = this.getAttribute("data-variant-id");
      const productId = this.getAttribute("data-product-id");
      const selectedPurchaseType = parentElement.querySelector(
        'input[name="purchase_type_' + productId + '"]:checked'
      ).value;

      let formData = {
        items: [
          {
            id: variantId,
            quantity: parseInt(quantity),
            selling_plan:
              selectedPurchaseType !== "one_time"
                ? selectedPurchaseType
                : undefined,
          },
        ],
      };

      addToCart(formData, this);
    });
  });
});

function decreaseQuantity(event) {
  const quantityInput = event.currentTarget.nextElementSibling;
  let quantity = parseInt(quantityInput.value);
  if (quantity > 1) {
    quantity--;
    quantityInput.value = quantity;
    updatePrice();
  }
}

function increaseQuantity(event) {
  const quantityInput = event.currentTarget.previousElementSibling;
  let quantity = parseInt(quantityInput.value);
  quantity++;
  quantityInput.value = quantity;
  updatePrice();
}

function updatePrice() {
  const productItems = document.querySelectorAll(".card_productGrid__formItem");
  productItems.forEach((item) => {
    const quantity = parseInt(item.querySelector(".quantity-input").value);
    const oneTimePriceElement = item.querySelector('input[value="one_time"]');
    const oneTimePrice = parseFloat(oneTimePriceElement.getAttribute("data-price").replace("$", "").replace(",", ""));
    const subscriptionRadio = item.querySelector('input:not([value="one_time"]):checked');
    const subscriptionPrice = subscriptionRadio ? parseFloat(subscriptionRadio.getAttribute("data-price").replace("$", "").replace(",", "")) : null;

    const productPriceElement = item.querySelector("#card_product-price");
    const totalPriceOneTime = oneTimePrice * quantity;
    const formattedOneTimePrice = "$" + totalPriceOneTime.toFixed(2);

    if (subscriptionRadio && subscriptionRadio.checked) {
      const totalPriceSubscription = subscriptionPrice * quantity;
      const formattedSubscriptionPrice = "$" + totalPriceSubscription.toFixed(2);
      productPriceElement.innerHTML = `<span style="text-decoration: line-through;">${formattedOneTimePrice}</span><br>${formattedSubscriptionPrice}`;
      productPriceElement.style.marginTop = "-30px";
    } else {
      productPriceElement.textContent = formattedOneTimePrice;
      productPriceElement.style.marginTop = "0";
    }
  });
}

function addToCart(formData, button) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Added to cart:", data);
      button.textContent = "added to cart";
      resetQuantity(button);
      updateCartCountBubble();
      setTimeout(() => {
        button.textContent = "Add to Cart";
        button.disabled = false;
      }, 2000);
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
      button.textContent = "Error";
      setTimeout(() => {
        button.textContent = "Add to Cart";
        button.disabled = false;
      }, 2000);
    });
}

function resetQuantity(button) {
  const parentElement = button.closest(".card_productGrid__formItem");
  const quantityInput = parentElement.querySelector(".quantity-input");
  quantityInput.value = 1;
  updatePrice();
}

function updateCartCountBubble() {
  fetch("/cart.js") 
    .then((response) => response.json())
    .then((cartData) => {
      let cartBubble = document.querySelector(".cart-count-bubble");
    
        cartBubble.style.display = "block";
   
        
      if (!cartBubble) {
        cartBubble = document.createElement("div");
        cartBubble.className = "cart-count-bubble jojojo";
        cartBubble.innerHTML = "<span>" + cartData.item_count + "</span>";
        document.body.appendChild(cartBubble); // Append to a specific part of your layout if needed
      } else {
        cartBubble.querySelector("span").textContent = cartData.item_count;
      }
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    });
}
